/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 19:43:00
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";
export default class MeasureTypeApi {
	/**
	 * 查询列表
	 * @param {UnitConfigDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: PageDo={page_index: 1, page_size: 1000000}):Promise<ResultPageDo<{name: string, id: number}[]>> {
		return Api.post('/monitor/measuring/type/query', params)
    }
    static async searchMeasureType():Promise<Result<{data_name: string, id: number}[]>> {
		return Api.post('/monitor/point/data_type/data')
	}
	/**
	 * 查询列表
	 * @param {{id: number}} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchRelation (measuring_type_id: number): Promise<Result<{data_name: string, data_type_id: number}[]>> {
		return Api.post('/monitor/measuring/type/data_type/data', {measuring_type_id})
    }
    static async updateRelation (measuring_type_id: number,data_type_ids: number[]): Promise<Result<any[]>> {
		return Api.post('/monitor/measuring/type/data_type/add', {measuring_type_id,data_type_ids})
	}
	/**
	 * 新增
	 * @param {UnitConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async add(name: string):Promise<Result<any>> {
		return Api.post('/monitor/measuring/type/add', {name})
	}

	/**
	 * 修改
	 * @param {UnitConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async update(name: string, measuring_type_id: number):Promise<Result<any>> {
		return Api.post('/monitor/measuring/type/edit', {name, measuring_type_id})
	}

	/**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async delete(measuring_type_id: number):Promise<Result<any>> {
		return Api.post('/monitor/measuring/type/delete', {measuring_type_id})
	}
}